import React, { useState } from "react";
import { MdDeleteOutline, MdDownload } from "react-icons/md";
import TempFour from "../../components/helpers/walletTabs/tempFour";
import { useAppSelector } from "../../utils/redux/hooks";
import { RootState } from "../../utils/redux/store";
const Provider4 = () => {
  const [currentPage] = useState(1);
  const itemsPerPage = 10;  const totalItems = 1245;


  const allItems = Array.from({ length: itemsPerPage }, (_, index) => ({
    id: index + 1,
    name: `First Last ${index + 1}`,
    phoneNumber: `0805214256${index}`,
    email: `example${index}@example.com`,
    dob: `12/02/1991`,
    gender: `female`,
    address: `24, Nana Avenue, Sangotedo, Lagos`,
    nationality: `Nigerian`,
  }));

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  const data = { endIndex, allItems };
  console.log(data);

  const [actionModal] = useState(false);

  return (
    <>
      <div className="relative  px-3">

       <TempFour />

        {actionModal && (
          <>
            <div className="flex flex-col gap-8 w-[10rem] p-4 absolute top-44 right-[30rem] z-50 rounded-md border border-[#88087B] bg-[#fff]">
              <p className="flex gap-2 items-center font-bold cursor-pointer">
                <MdDownload size={25} className="" />
                Export
              </p>
              <p className="flex gap-2 items-center text-[#D11C1C] font-bold cursor-pointer">
                <MdDeleteOutline size={25} className=" text-[#D11C1C]" />
                Delete
              </p>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Provider4;
